/**
 * Nigerian state detection from a Google Places address string.
 * Mirrors backend/services/pricingEngine.js detectState() — keep in sync.
 *
 * Returns a normalised state name (e.g. "Lagos", "Oyo", "Abuja") or null.
 */

const NIGERIAN_STATES = [
  "Abia", "Adamawa", "Akwa Ibom", "Anambra", "Bauchi", "Bayelsa", "Benue",
  "Borno", "Cross River", "Delta", "Ebonyi", "Edo", "Ekiti", "Enugu",
  "Gombe", "Imo", "Jigawa", "Kaduna", "Kano", "Katsina", "Kebbi", "Kogi",
  "Kwara", "Lagos", "Nasarawa", "Niger", "Ogun", "Ondo", "Osun", "Oyo",
  "Plateau", "Rivers", "Sokoto", "Taraba", "Yobe", "Zamfara",
  // FCT aliases
  "FCT", "Abuja",
];

/**
 * @param {string|null|undefined} address
 * @returns {string|null}  Normalised state name, e.g. "Lagos", or null
 */
export function detectNigerianState(address) {
  if (!address || typeof address !== "string") return null;
  for (const state of NIGERIAN_STATES) {
    const regex = new RegExp(`\\b${state.replace(/\s+/g, "\\s+")}\\b`, "i");
    if (regex.test(address)) {
      // Normalise FCT / Abuja → "Abuja"
      const lower = state.toLowerCase();
      if (lower === "fct" || lower === "abuja") return "Abuja";
      return state;
    }
  }
  return null;
}
